export default [
  {
    path: '/production',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Production',
        component: () => import('./containers/ProductionContainer'),
      },
    ],
  },
]
